import React, {Component} from 'react';

class Intestazione extends Component {
    componentDidMount() {
        this.showAnimatedHeader();
    }

    componentDidUpdate() {
        this.showAnimatedHeader();
    }

    showAnimatedHeader() {
        if (this.headerContent) {
            this.headerContent.classList.add('fadeInUp', 'ftco-animated');
            this.headerContent.style.visibility = 'visible';
            this.headerContent.style.opacity = '1';
        }
    }

    render() {
        const TitoloTag = this.props.titoloAs || 'h1';
        const breadcrumbItems = this.props.breadcrumbItems || [
            {
                label: this.props.pagina,
                href: this.props.paginaHref,
            },
        ];

        return (
            <section id="home" className="hero-wrap" style={this.props.backgroundStyle}>
                <div className="overlay"></div>
                <div className="container">
                    <div className="row no-gutters text align-items-center justify-content-center">
                        <div className="col-lg-10 col-md-11 ftco-animate text-center" ref={el => (this.headerContent = el)}>
                            <p className="breadcrumbs">
                                <span className="mr-2"><a href="/">Torna al romanzo</a></span>
                                {breadcrumbItems.map((item, index) => (
                                    <React.Fragment key={`${item.label}-${index}`}>
                                        <span className="breadcrumb-separator" aria-hidden="true">›</span>
                                        <span>{item.href ? <a href={item.href}>{item.label}</a> : item.label}</span>
                                    </React.Fragment>
                                ))}
                            </p>
                            <TitoloTag className="bread">{this.props.titolo}</TitoloTag>
                            <span className="subheading hero-subheading">{this.props.romanzo}</span>
                            <h3 className="hero-author">{this.props.autore}</h3>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Intestazione;
